import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import api from '../services/api';

const FeatureFlagsContext = createContext();

export const FeatureFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // ✅ Ne charger QUE si l'utilisateur est authentifié
    if (isAuthenticated()) {
      loadFeatureFlags();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated]);

  const loadFeatureFlags = async () => {
    try {
      // 1. Essayer de charger depuis localStorage
      const cached = localStorage.getItem('horapilot_feature_flags');
      if (cached) {
        const parsed = JSON.parse(cached);
        setFlags(parsed);
        setLoading(false);
        console.log('✅ [FeatureFlags] Chargé depuis localStorage:', parsed);
      }

      // 2. Charger depuis l'API (en arrière-plan)
      const response = await api.features.getUserFlags();
      
      if (response.success) {
        const flagsMap = {};
        response.flags.forEach(flag => {
          flagsMap[flag.feature_name] = Boolean(flag.is_enabled);
        });
        
        setFlags(flagsMap);
        localStorage.setItem('horapilot_feature_flags', JSON.stringify(flagsMap));
        console.log('✅ [FeatureFlags] Chargé depuis API:', flagsMap);
      }
    } catch (error) {
      console.error('❌ [FeatureFlags] Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const isEnabled = (flagName) => {
    return flags[flagName] === true;
  };

  const refresh = () => {
    localStorage.removeItem('horapilot_feature_flags');
    loadFeatureFlags();
  };

  return (
    <FeatureFlagsContext.Provider value={{ flags, loading, isEnabled, refresh }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagsContext);
  if (!context) {
    throw new Error('useFeatureFlags doit être utilisé dans un FeatureFlagsProvider');
  }
  return context;
};